import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=64a5e71e&scoped=true"
import script from "./TemplateList.vue?vue&type=script&lang=js"
export * from "./TemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a5e71e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a5e71e')) {
      api.createRecord('64a5e71e', component.options)
    } else {
      api.reload('64a5e71e', component.options)
    }
    module.hot.accept("./TemplateList.vue?vue&type=template&id=64a5e71e&scoped=true", function () {
      api.rerender('64a5e71e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/questionnaire/template/TemplateList.vue"
export default component.exports